var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconButtonDisabled = function SvgIconButtonDisabled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99382e-07 8C1.08564e-06 3.58176 3.58176 -1.08564e-06 8 -6.99382e-07C12.4183 -3.13124e-07 16 3.58176 16 8C16 12.4183 12.4183 16 8 16C3.58176 16 3.13124e-07 12.4183 6.99382e-07 8ZM7.2 11.2C7.2 10.7582 7.55816 10.4 8 10.4C8.44184 10.4 8.8 10.7582 8.8 11.2C8.8 11.6418 8.44184 12 8 12C7.55816 12 7.2 11.6418 7.2 11.2ZM8 9.6C8.44184 9.6 8.8 9.24184 8.8 8.8L8.8 4.8C8.8 4.35816 8.44184 4 8 4C7.55816 4 7.2 4.35816 7.2 4.8L7.2 8.8C7.2 9.24184 7.55816 9.6 8 9.6Z",
    fill: "#D85E62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconButtonDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-button-disabled.4541408180bf704911a565dbf86c16ea.svg";